/**
 * Core application UI actions
 */

import { LocalStorageHelper } from '../../../helpers';
import { logger } from '../../../helpers/logger';
import { AppDispatch } from '../../../store';
import { uiConstants } from './actionTypes';
import { appApi } from '../../../services/appApi';
import queryString from 'query-string';

//////////////////////////////////////////////////////////////////////////
//
// Helper functions
//

const _initializeUiAddin = (payload: {
    displayLanguage: string;
    pageMode: string;
}) => ({
    type: uiConstants.UI_INITIALIZE_ADDIN,
    payload,
});

/**
 * Initializes the addin
 * @param inputLocation
 */
const initializeAddinUi = (inputLocation: Location) => {
    return async (dispatch: AppDispatch) => {
        logger.info('initializeAddinUi action called', 'Init');
        let displayLanguage = LocalStorageHelper.storeContainsKey(
            LocalStorageHelper.storeKeys.LANG,
        )
            ? (LocalStorageHelper.storeGetObject(
                  LocalStorageHelper.storeKeys.LANG,
              ) ?? '')
            : navigator.language.substring(0, 2).toLowerCase();

        const { page } = queryString.parse(inputLocation.search);
        // only well-formed urls (?page=share) yield a string; treat anything
        // else (missing, valueless or repeated ?page) as "no page specified"
        const pageMode = typeof page === 'string' ? page : '';

        // Need to add logic to check is language isn't in the list
        // of supported languages - select "EN" then
        const config = await appApi.getConfig();
        if (!config.supportedLanguages.includes(displayLanguage))
            displayLanguage = 'en';

        dispatch(
            _initializeUiAddin({
                displayLanguage: displayLanguage,
                pageMode: pageMode,
            }),
        );
    };
};

export const uiActions = {
    initializeAddinUi,
};
